<script>
    import Gallary from "./gallary.svelte";
    import { estimate_gallery_mbl } from "./gallary.js";
    import { show } from "./store.js";
    import YourPlan from "./submit_your_plan.svelte";

    let bullet = [
        {
            step: "Step 1",
            point: "You send us project details and we translate them into digital quantities using our state-of-the-art software system.",
        },
        {
            step: "Step 2",
            point: "After the data is assembled, the takeoff quantities will be transferred and organized into specific outlines on excel spreadsheets.",
        },
        {
            step: "Step 3",
            point: "Once we calculate the price of labor and material costs by conducting an analysis of wages and pricing, we will suggest the best price that you can finalize.",
        },
        {
            step: "Step 4",
            point: "To complete the process, our lead estimator will conduct a final check to review the quality of the project deliverables to maintain quality control.",
        },
    ];
    let text = [
        {
            heading: "You Send Us Your Plans to Review",
            info: " You can send them to <a style='color:#3C88C3; font-weight: bold; ' href='mailto:hello@automason.ai'>hello@automason.ai</a> or if they are large files, upload through our Dropbox.",
        },
        {
            heading: "We Estimate and Send you Your Project",
            info: " Our team will digitally takeoff the quantities for your project and prepare your entire bid for you. We use a highly accurate cost database that’s based on the zip code so the numbers will be extremely accurate and competitive.",
        },
        {
            heading: "We Send you a Quote for the Project",
            info: " Before starting, we’ll send you a detailed quote for our services. We look at things like size, difficulty, complexity, and bid date when determining pricing. Every project is unique so we take the time to review each project individually.",
        },
    ];

    function displayPopUp() {
        show.update((n) => n + 1);
        console.log("show", show);
    }
</script>


<div class="mobile">
<div
    style="font-size: 3.271vw; line-height:4.579vw;text-align: center;
            font-weight: 500;margin-top: 11.449vw;Font-family: 'Poppins';
            
            width:73.598vw; margin-left:13.318vw;"
>
    We use proven strategies to help you churn the numbers into the BEST deals
    possible by giving you real time support and foolproof advice on how to
    negotiate.
</div>
<div
    style="width:73.598vw; margin-left:13.318vw; font-weight: 400;
     font-size:2.804vw; line-height:3.925vw;margin-top: 5vw; text-align:center;"
>
    What we’re providing is an easy estimation process that lands you the bids
    that you want without the hassle of it all. By cutting your time in half,
    and using solid methods to close, you’ll make all your projects successful,
    all within a few clicks!
</div>

<h1
    style="font-size:5.607vw; text-transform: uppercase;
         margin-bottom: 11.682vw; margin-left: 30vw; margin-top:15.421vw;"
>
    Our Services
</h1>

<div
    style="margin-top: 4.948vw; margin-bottom:3vw; margin-right: 7.5vw;margin-left: 7.5vw;"
>
    <Gallary
        coming_data={estimate_gallery_mbl}
        width="90vw; display:flex: flex-wrap: wrap;"
        font_size="3vw"
    />
</div>

<div style="width:69.617vw;margin-top:31.364vw;margin-left:15.692vw;">
    <img
        class="lines"
        src="images/estimate_gallery/lines.svg"
        alt=""
        width="100%"
        height="30%"
    />
    <h1
        style="font-size:5.607vw; margin-top:-17vw;font-weight: 600;
           line-height: 7.944vw;letter-spacing: 0vw;text-align: center;"
    >
        The Estimation <br />Procedure We Follow:
    </h1>
</div>

<div style="display: flex;margin-left: 16.495vw; margin-top: 16.421vw; ">
    <div>
        <ul style="list-style-type:none;width: 53.738vw; ">
            {#each bullet as data}
                <li>
                    <p
                        style="font-weight: 600;font-size:2.804vw; margin-bottom:-2vw; text-transform:uppercase;"
                    >
                        {data.step}
                    </p>
                    <p
                        style="font-size:2.804vw; font-weight:400; line-height:3.925vw; margin-bottom:9.346vw;"
                    >
                        {data.point}
                    </p>
                </li>
            {/each}
        </ul>
    </div>
</div>

<div>
    <h5
        on:click={() => {
            displayPopUp();
        }}
        style="font-family: 'Inter';font-weight:600;font-size:3.738vw; color:#F36532; margin-left: 18.692vw; margin-top: 2.804vw;"
    >
        Get a Quote <img
            style="margin-bottom:-0.5vw; margin-left:2vw; width:4.907vw;"
            src="/images/estimate_gallery/arrow.svg"
            alt=""
        />
    </h5>

    <hr />
    <div>
        <div style="width:69.617vw;margin-top:19.364vw;margin-left:15.692vw;">
            <img
                class="lines"
                src="images/estimate_gallery/lines.svg"
                alt=""
                width="100%"
                height="30%"
            />
            <h1
                style="font-size:5.607vw; margin-top:-17.5vw;font-weight: 600;
               line-height: 7.944vw;letter-spacing: 0vw;text-align: center;"
            >
                Benefits of choosing AUTOMASON
            </h1>
        </div>
    </div>

    <div style="position:relative;  top:14vw;">
        <img
            src="images/estimate_gallery/benefits.png"
            alt=""
            style="width: 34.813vw; margin-left:56.542vw;margin-top:3vw;"
        />

        <div
            style="height: 39.252vw; width: 43.224vw; left:7.710vw;position: absolute;top:0vw;"
        >
            <img
                src="images/estimate_gallery/0.1.svg"
                alt=""
                style="width:13.084vw; position:absolute; top:8vw;left:31vw"
            />

            <p
                style="position: absolute; font-size:2.8vw; font-weight:400;line-height: 3.925vw; top: 0vw;"
            >
                We have your results in <br /> up to 48 hours
            </p>

            <img
                src="images/estimate_gallery/0.2.svg"
                alt=""
                style="width:7.710vw; position:absolute; top:23vw; left:35vw;"
            />

            <p
                style="position: absolute; font-size:2.8vw; font-weight:400;line-height: 3.925vw; top: 14.720vw;"
            >
                There is no additional <br /> cost
            </p>
            <img
                src="images/estimate_gallery/0.3.svg"
                alt=""
                style="width:14.252vw; position:absolute; top:40vw; left:30vw;"
            />

            <p
                style="position: absolute; font-size:2.8vw; font-weight:400;line-height: 3.925vw; top: 31.075vw; "
            >
                Estimates are guaranteed to <br /> be accurate
            </p>
        </div>

        <div style="position:relative; top: 20.925vw;">
            <img
                src="images/estimate_gallery/touch_mbl.png"
                alt=""
                style="width: 34.813vw;margin-left:7vw;"
            />
            <div
                style="position: absolute;top: 0vw; height: 39.252vw; width: 48.664vw; left:45.729vw;"
            >
                <img
                    src="images/estimate_gallery/0.4.svg"
                    alt=""
                    style="width:13.084vw; position:absolute; top:7vw; "
                />

                <p
                    style="position: absolute; font-size:2.8vw; font-weight:400;line-height: 3.925vw; left:14.888vw;"
                >
                    We provide help by <br /> telephonic consultancy
                </p>

                <img
                    src="images/estimate_gallery/0.5.svg"
                    alt=""
                    style="width:12.617vw; position:absolute; top:21vw;"
                />

                <p
                    style="position: absolute; font-size:2.8vw; font-weight:400;line-height: 3.925vw; top:14vw; left:14.888vw;"
                >
                    Our reports are easy <br /> to understand
                </p>

                <img
                    src="images/estimate_gallery/0.6.svg"
                    alt=""
                    style="width:7.944vw; position:absolute; top: 38vw;"
                />

                <p
                    style="position: absolute;font-size:2.8vw; font-weight:400;line-height: 3.925vw; top: 28.075vw; left:14.888vw;"
                >
                    Team of experienced <br /> estimates is at your <br /> disposal
                </p>
            </div>
        </div>
    </div>
    <hr class="two" />

    <div style="position:relative;">
        <div style="width:69.617vw;margin-top:25.364vw;margin-left:15.692vw;">
            <img
                class="lines"
                src="images/estimate_gallery/lines.svg"
                alt=""
                width="100%"
                height="20%"
            />
            <h1
                style="font-size:5.607vw;font-weight: 600; margin-top: -17.5vw;
               line-height: 7.944vw;letter-spacing: 0em;text-align: center;"
            >
                How do I get a <br /> project estimated?
            </h1>
        </div>
    </div>
    <div
        style="background-color: #F9F6EF; height:118.925vw; margin-top: 7.944vw;"
    >
        <div
            style="    margin-left:11.449vw; padding-top: 1vw; width: 77.103vw;"
        >
            {#each text as data}
                <p
                    style="font-weight: 600;font-size:2.804vw; line-height:0.925vw;  margin-top: 7.944vw;"
                >
                    {data.heading}
                </p>
                <p
                    style="font-size:2.804vw; font-weight:400; line-height:3.925vw;margin-bottom: 9vw;"
                >
                    {@html data.info}
                </p>
            {/each}
        </div>

        <div>
            <h5
                on:click={() => {
                    displayPopUp();
                }}
                style="font-family: 'Inter';font-weight:600;font-size:3.738vw; color:#F36532; margin-left:12vw; margin-top: 2.804vw;"
            >
                Get a Quote <img
                    style="margin-bottom:-0.5vw; margin-left:2vw; width:4.907vw;"
                    src="/images/estimate_gallery/arrow.svg"
                    alt=""
                />
            </h5>
        </div>
    </div>
</div>
</div>
<style>
    li::before {
        content: "";
        position: absolute;
        background-color: #ff6d24;
        border-right: solid black 0.2vw;
        width: 1.2vw;
        height: 3.5vw;
        margin-left: -5vw;
        margin-top: 3vw;
    }

    hr {
        margin-top: 23.935vw;
        margin-left: 15.888vw;
        background-color: #eae7e7;
        border: 0.1vw #eae7e7 solid;
        width: 68.224vw;
    }

    .two {
        margin-top: 57.935vw;
        margin-left: 15.888vw;
        background-color: #eae7e7;
        border: 0.234vw #eae7e7 solid;
        width: 68.224vw;
    }

    .lines {
        opacity: 60%;
    }
</style>
